/**
 * Site-wide configuration for SEO and meta tags.
 * SITE_URL should be set via VITE_SITE_URL env var for different environments.
 */
export const SITE_URL = import.meta.env.VITE_SITE_URL || "https://rusha.io";

export const SITE_NAME = "Rusha";
export const SITE_DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.png`;

export const ROUTES = {
  HOME: "/",
  TEMPLATES: "/templates",
  DOCS: "/docs",
} as const;

export function canonicalUrl(path: string): string {
  return `${SITE_URL}${path}`;
}
